<script setup lang="ts">
import type { ClientResult } from '~/types/Clients';

defineProps<{
    item: ClientResult
}>()
</script>

<template>
	<div class="gap-x-8 gap-y-4 rounded-xl flex flex-col flex-1 px-4 py-5 sm:p-6">
							<div class="">
								<div class="mb-2 pointer-events-none">
									<Icon :name="`ph:${item.icon}`" class="w-8 h-8 flex-shrink-0 text-gray-900 dark:text-white" />
								</div>
								<p class="text-primary text-base font-bold truncate">Sector</p>
								<p class="text-base font-bold truncate text-xl" v-html="item.sector"></p>

								<p class="text-primary text-base font-bold truncate pt-3">Services</p>

								<ul>
									<li v-for="solution in item.solutions" :key="solution" class="text-base truncate text-sm" v-html="'• '+solution"></li>
								</ul>

								<p class="text-primary text-base font-bold truncate pt-3">Results</p>

								<ul>
									<li v-for="result in item.results" :key="result" class="text-base truncate text-sm" v-html="'• '+result"></li>
								</ul>

								<p class="text-primary text-base font-bold truncate pt-3">Tooling</p>

								<div class="grid grid-cols-12 gap-2 pt-2">
									<div v-for="tool in item.tools" :key="tool">
										<img :src="`/assets/images/apps/${tool.replace(' ', '-').toLowerCase()}.png`" width="20px" height="20px" :alt="tool" loading="lazy" class="rounded-xl">
									</div>
								</div>
							</div>
						</div>
</template>
